export type TechnologyBadgeVariant =
  | "apple"
  | "google"
  | "samsung"
  | "app"
  | "default";

export type TechnologyBadge = {
  platformBadge: string;
  platformBadgeVariant: TechnologyBadgeVariant;
};

export const getTechnologyBadgeVariant = (
  technology: string
): TechnologyBadgeVariant => {
  const lower = technology.toLowerCase().trim();

  if (lower.startsWith("apple wallet")) {
    return "apple";
  }

  if (lower.startsWith("google wallet")) {
    return "google";
  }

  if (lower.startsWith("samsung wallet")) {
    return "samsung";
  }

  if (lower === "app based" || lower.includes("app base")) {
    return "app";
  }

  return "default";
};

export const mapTechnologyToBadge = (technology: string): TechnologyBadge => {
  const platformBadgeVariant = getTechnologyBadgeVariant(technology);
  const lower = technology.toLowerCase().trim();

  if (lower.startsWith("apple wallet")) {
    return { platformBadge: "Apple", platformBadgeVariant };
  }

  if (lower.startsWith("google wallet")) {
    return { platformBadge: "Google", platformBadgeVariant };
  }

  if (lower.startsWith("samsung wallet")) {
    return { platformBadge: "Samsung", platformBadgeVariant };
  }

  if (lower === "app based" || lower.includes("app base")) {
    return { platformBadge: "App", platformBadgeVariant };
  }

  return {
    platformBadge:
      technology.length > 12 ? technology.split(" ")[0] : technology,
    platformBadgeVariant,
  };
};
